module.exports = __webpack_public_path__ + "fc71cd8a12fff5e6219d5c304e2b3d07.MP3";